import getters from './getters'
import mutations from './mutations'

export default {
  state: {
    toastr: {
      time: 2000,
      color: '',
      visibility: false,
      text: '',
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000
    }
  },
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/toastr/index.js